<template>
    <div>
        <div v-if="!showThankYou" :class="['breadcrumbs-wrapper', {'breadcrumbs-wrapper--wide': showForm}]">
            <div class="container">
                <div class="breadcrumbs">
                    <a href="/career#anchor-open-positions">Open positions</a>
                    <span class="material-symbols-rounded">chevron_right</span>
                    <template v-if="showForm">
                        <a :href="`/career/detail?position=${id}&title=${detail.title}`">{{ detail.title }}</a>
                        
                        <span class="material-symbols-rounded">chevron_right</span>
                        <strong>Job form</strong>
                    </template>
                    <template v-else>
                        <strong>{{ detail.title }}</strong>
                    </template>
                </div>
            </div>
        </div>

        <section class="open-positions-detail">
            <div :class="['open-positions-detail-wrapper', {'open-positions-detail-form-wrapper': showForm, 'open-positions-thank-you-wrapper': showThankYou, 'fetching': isFetching}]">
                <div class="position-detail" v-if="!isFetching && showDetailPosition">
                    <h1 class="new-headline-lg">{{ detail.title }}</h1>
                    <div class="basic">
                        <div>
                            <figure>
                                <span class="material-symbols-rounded">location_on</span>
                            </figure>
                            <p class="new-text-lg" v-html="region"></p>
                        </div>
                        <div>
                            <figure>
                                <span class="material-symbols-rounded">schedule</span>
                            </figure>
                            <p class="new-text-lg" v-html="typeOfJob"></p>
                        </div>
                    </div>
                    <div class="short-description" v-html="detail.shortDescription"></div>
                    <div class="description" v-html="detail.description"></div>
                    <div class="requirements" v-html="detail.requirements"></div>
                    <div class="offer" v-html="detail.offer"></div>
                    <div class="footer">
                        <locket :name="detail.positionOwner"></locket>
                        <v-button
                            label="I want to apply"
                            @onClick="showDetailPosition = false"
                        >
                        </v-button>
                        <div class="share">
                            <div>
                                <figure>
                                    <svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.6484 11.9482L7.71875 11.9482L7.71875 20.6982L3.8125 20.6982L3.8125 11.9482L0.609375 11.9482L0.609375 8.35449L3.8125 8.35449L3.8125 5.58105C3.8125 2.45605 5.6875 0.698242 8.53906 0.698242C9.90625 0.698242 11.3516 0.97168 11.3516 0.97168L11.3516 4.05762L9.75 4.05762C8.1875 4.05762 7.71875 4.99512 7.71875 6.01074L7.71875 8.35449L11.1953 8.35449L10.6484 11.9482Z" fill="white"/>
                                    </svg>
                                </figure>
                                <a class="new-text-md text-color-default" :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUrlFacebook}`" target="_blank">Share on Facebook</a>
                            </div>
                            <div>
                                <figure>
                                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.15625 18.1982L0.523437 18.1982L0.523437 6.51855L4.15625 6.51855L4.15625 18.1982ZM2.32031 4.95605C1.1875 4.95605 0.25 3.97949 0.25 2.80762C0.25 1.6748 1.1875 0.737305 2.32031 0.737305C3.49219 0.737305 4.42969 1.6748 4.42969 2.80762C4.42969 3.97949 3.49219 4.95605 2.32031 4.95605ZM17.7109 18.1982L14.1172 18.1982L14.1172 12.5342C14.1172 11.167 14.0781 9.44824 12.2031 9.44824C10.3281 9.44824 10.0547 10.8936 10.0547 12.417L10.0547 18.1982L6.42187 18.1982L6.42187 6.51855L9.89844 6.51855L9.89844 8.12012L9.9375 8.12012C10.4453 7.22168 11.6172 6.24512 13.375 6.24512C17.0469 6.24512 17.75 8.66699 17.75 11.792L17.75 18.1982L17.7109 18.1982Z" fill="white"/>
                                    </svg>
                                </figure>
                                <a class="new-text-md text-color-default" :href="`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrlLinkedIn}`" target="_blank">Share on LinkedIn</a>
                            </div>
                        </div>
                    </div>
                </div>

                <OpenPositionsDetailThankYou v-if="showThankYou" :locket="detail.positionOwner" />
                <OpenPositionsDetailForm v-if="showForm && !isFetching" @form-done="showThankYouScreen()" :jobId="id" :locket="detail.positionOwner" :position="detail.title" :workType="typeOfJob" :region="region" :positionUrl="positionUrl" :privacyLangEn="privacyLangEn"/>
            </div>
        </section>
    </div>
</template>

<script>
import OpenPositionsDetailForm from './OpenPositionsDetailForm';
import OpenPositionsDetailThankYou from './OpenPositionsDetailThankYou';

export default {
    components: { OpenPositionsDetailThankYou, OpenPositionsDetailForm },
    props: {
        positionUrl: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            showDetailPosition: true,
            showThankYou: false,
            showForm: false,
            isFetching: true,
            id: null,
            detail: {
                title: null,
                workType: {},
                shortDescription: null,
                description: null,
                requirements: null,
                offer: null,
                positionOwner: null,
                regionIdCountry: null,
                region: null

            },
            regions:{
                de: ['Germany', 'Deutschland'],
                cz: ['Czech Republic', 'Czech Republic'],
                sk: ['Slovakia', 'Slovakia'],
                it: ['Italy', 'Italia']
            },
            typeOfJob: null,
            region: null,
            url: 'www.vitad.io',
            privacyLangEn: true
        };
    },

    watch: {
        showDetailPosition(){
            let uri = new URI(location.href)

            this.showForm = true
            history.pushState(null, '', uri + '&form=show');
        }
    },

    created(){
        this.getId()
    },

    mounted() {
        const instance = axios.create()
        let uri = new URI(location.href)

        if (this.id) {       
            instance
            .get(`/api/datacruit?url=advertising/jobAds/${this.id}`)
            .then((res) => {
                this.bindData(res.data)
                this.isFetching = false

                if (uri.hasQuery('form', 'show') === true) {
                    this.showDetailPosition = false
                }
            })
            .catch((e) => {
                console.log(e)
                this.isFetching = false
            })
        }
    },

    computed: {
        shareUrlFacebook() {
            return this.positionUrl.replaceAll('&', '%26')
        },
        shareUrlLinkedIn() {
            return this.shareUrlFacebook.replaceAll('=', '%3D')
        }
    },  

    methods: {        
        showThankYouScreen() {
            this.showThankYou = true
            this.showForm = false
        },

        getId(){
            const url = new URLSearchParams(window.location.search);
            this.id = url.get('position');
        },

        bindData(data){
            let assign = this.detail
            assign.title = data.title
            assign.regionIdCountry = data.regionIdCountry
            assign.region = data.region
            assign.workType = {
                parttime: data.parttime,
                fulltime: data.fulltime,
                contractor: data.contractor,
            }
            assign.shortDescription = this.deleteEmptyTags(data.descriptionShort)
            assign.description = this.deleteEmptyTags(data.description)
            assign.requirements = this.deleteEmptyTags(data.requirements)
            assign.offer = this.deleteEmptyTags(data.offer)
            assign.positionOwner = data.contactFullname.split(' ')[0].toLowerCase()

            this.setTypeOfJob(this.detail.workType.parttime, this.detail.workType.fulltime, this.detail.workType.contractor)
            this.setRegion(this.detail.regionIdCountry, this.detail.region)
        },
        
        deleteEmptyTags(text){
            const deleteEmptyTags = ['<br>','<p></p>']

            let newString = text

            for(let string in deleteEmptyTags){
                newString = newString.replaceAll(deleteEmptyTags[string], '')
            }

            return newString

        },

        setTypeOfJob(parttime, fulltime, contractor){
            const typeOfJobArr = []

            if (parttime) {
                typeOfJobArr.push('Part-time job')
            }

            if (fulltime) {
                typeOfJobArr.push('Full-time job')
            }

            if (contractor) {
                typeOfJobArr.push('Contractor')
            }

            const spaceArr = typeOfJobArr.join(', ')
            this.typeOfJob = spaceArr.toString()
        },

        setRegion(regionId, regionCity){
            this.region = `${this.regions[regionId][0]} - ${regionCity}`

            if (regionId === 'cz') {
                this.privacyLangEn = false
            }

            if (regionCity === this.regions[regionId][0] || regionCity === this.regions[regionId][1]) {
                this.region = this.regions[regionId][0]
            }
        },
    },
}
</script>

